var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasExtencion('ventas_con_fecha_de_entrega') && !_vm.budget)?_c('b-input-group',{staticClass:"w-300 m-b-10",attrs:{"prepend":"Fecha de Entrega"}},[_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.fecha_entrega),callback:function ($$v) {_vm.fecha_entrega=$$v},expression:"fecha_entrega"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }